var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Datepicker',{attrs:{"cloudyDates":_vm.cloudyDates,"disabledDates":_vm.disabledDates,"loading":_vm.loading},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }